import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./tags.module.css";
export var Tags = function(param) {
    var fuelType = param.fuelType, transmissionType = param.transmissionType, mileage = param.mileage, year = param.year;
    var tagsList = [
        {
            label: "Vehicle Year",
            value: year
        },
        {
            label: "Mileage",
            value: "".concat(Intl.NumberFormat().format(mileage), " miles")
        },
        {
            label: "Fuel Type",
            value: fuelType
        },
        {
            label: "Transmission Type",
            value: transmissionType
        }, 
    ];
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.container,
        children: tagsList.map(function(param) {
            var label = param.label, value = param.value;
            return /*#__PURE__*/ _jsx("li", {
                className: styles.tag,
                children: /*#__PURE__*/ _jsx("p", {
                    className: styles.tagText,
                    children: value
                })
            }, label);
        })
    });
};
